import React, { useState } from "react";

const Script = () => {
  const orgName = sessionStorage.getItem('organizationName');
  const organization_id = sessionStorage.getItem(`${orgName}_organizationId`);
  const codeExample = `<!-- 4X Chat Widget -->
<div id="my-chat-widget"></div>
<script src="https://myclient.4xp.chat/assets/index-DL7U2gxx.js" organizationId="${organization_id}"></script>
<script>
    (function() {
        const scriptTag = document.querySelector('script[organizationId]');
        if (scriptTag) {
            sessionStorage.setItem('organization_id', scriptTag.getAttribute('organizationId'));
        }
    })();
    window.renderChatWidget();
</script>`;

  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    navigator.clipboard.writeText(codeExample);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (

    <div className="max-w-2xl mx-auto p-6 border rounded-lg shadow-lg ">
      {/* Title Section */}
      <div className="flex items-center gap-3 mb-4">
        <span className="text-lg font-semibold">Install 4X ChatWidget</span>
      </div>

      {/* Warning message */}
      <p className="text-red-500 font-medium">Install website widget ❗</p>
      <p className="text-gray-600 text-sm mb-4">
        To see ChatWidget on your website, you'll need to add a bit of code or configure an integration.
      </p>

      {/* Box with Code Block */}
      <div className="border rounded-lg bg-gray-50 p-4">
        <h3 className="font-semibold text-lg mb-2">Install chat widget manually</h3>
        <p className="text-gray-600 text-sm mb-2">
          1. Copy and paste this code before the <code className="text-blue-600">&lt;/body&gt;</code> tag of your website.
        </p>

        {/* Code Box */}
        <div className="relative bg-gray-900 text-white text-sm rounded-md p-4 overflow-auto">
          <pre className="whitespace-pre-wrap">{codeExample}</pre>
          {/* Copy Button */}
          <button
            onClick={handleCopy}
            className="absolute top-2 right-2 bg-blue-500 text-white px-3 py-1 rounded text-sm hover:bg-blue-600 transition"
          >
            {copied ? "Copied!" : "Copy Code"}
          </button>
        </div>
      </div>
    </div>

  );
};

export default Script;